import BookmarksInfoComponent from './BookmarkInfoComponent';

export default BookmarksInfoComponent;